import { useMutation, useQueryClient } from '@tanstack/react-query';
import { favoriteMarketService } from 'shared/src/api';
import { bridge } from 'shared/src/utils';
import { queryKey } from '../constant/queryKey';
import type { GoodsDetailResponse } from 'shared/src/api/goodsService/getGoodsDetail/types';
import { useGoodsSno } from '../hooks/useGoodsSno';

export const useDeleteFavoriteMarket = (marketId?: number) => {
  const goodsSno = useGoodsSno();
  const client = useQueryClient();

  return useMutation({
    mutationFn: () => {
      console.log('?????----', marketId);
      if (!marketId) {
        throw new Error('marketId must be defined');
      }
      return favoriteMarketService
        .delete({ sno: marketId })
        .then(res => res.data);
    },
    onSuccess: () => {
      bridge.favoriteMarket({ market_sno: marketId!, is_favorite: false });
      client.setQueryData<GoodsDetailResponse>(
        queryKey.goodsDetail(goodsSno),
        oldData => {
          if (!oldData) return oldData;
          return {
            ...oldData,
            goods: {
              ...oldData.goods,
              market: {
                ...oldData.goods.market,
                is_favorite: false,
              },
            },
          };
        },
      );
    },
  });
};
